<app-navbar></app-navbar>

<!-- Hero Section -->
<section class="devis-hero-section">
  <div class="container">
    <div class="hero-content">
      <h1>Demandez Votre Devis Personnalisé</h1>
      <p class="hero-subtitle">Obtenez une estimation détaillée et sur-mesure pour votre projet digital en quelques minutes</p>
    </div>
  </div>
</section>

<section class="devis-form-section">
  <div class="container">
    <div class="form-container">
      
      <div class="form-header">
        <h2>Formulaire De Demande De Devis</h2>
        <p>Remplissez ce formulaire pour recevoir un devis précis et personnalisé. Toutes les informations sont confidentielles.</p>
      </div>
      
      <div class="form-wrapper">
        <!-- Form Steps Indicator -->
        <div class="form-steps">
          <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
            <div class="step-number">1</div>
            <div class="step-label">CONTACT</div>
          </div>
          <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
            <div class="step-number">2</div>
            <div class="step-label">PROJET</div>
          </div>
          <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
            <div class="step-number">3</div>
            <div class="step-label">DÉTAILS</div>
          </div>
        </div>
        
        <!-- Success Message Alert -->
        <div *ngIf="submissionSuccess && !submissionError && !isSubmitting" class="success-alert">
          <div class="success-icon">✓</div>
          <div class="success-message">
            <strong>Demande de devis envoyée avec succès!</strong>
            <br>Nous avons bien reçu votre demande. 
            <br>Notre équipe analysera votre projet et vous enverra un devis personnalisé sous 24 heures.
          </div>
        </div>

        <!-- Error Message Alert -->
        <div *ngIf="submissionError" class="error-alert">
          <div class="error-icon">!</div>
          <div class="error-message">{{ submissionError }}</div>
        </div>
        
        <!-- THE MAIN FORM -->
        <form class="devis-form" #devisForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="!submissionSuccess">
          
          <!-- Step 1: Contact Information -->
          <div *ngIf="currentStep === 1" class="form-step">
            <h3 class="step-title">Informations De Contact</h3>
            
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Nom et Prénom <span class="required">*</span></label>
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Ex: Jean Dupont"
                  [(ngModel)]="formData.name"
                  name="name"
                  required>
              </div>
              
              <div class="form-group">
                <label class="form-label">Email <span class="required">*</span></label>
                <input 
                  type="email" 
                  class="form-control" 
                  placeholder="Ex: jean.dupont@entreprise.fr"
                  [(ngModel)]="formData.email"
                  name="email"
                  required
                  email>
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label">Nom de l'Entreprise <span class="required">*</span></label>
              <input 
                type="text" 
                class="form-control" 
                placeholder="Ex: Dupont & Associés SAS"
                [(ngModel)]="formData.company"
                name="company"
                required>
            </div>
            
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Téléphone</label>
                <div class="phone-input-group">
                  <div class="country-code">
                    <span class="code">(+33)</span>
                    <span class="arrow">▼</span>
                  </div>
                  <input 
                    type="tel" 
                    class="form-control" 
                    placeholder="6 XX XX XX XX"
                    [(ngModel)]="formData.phone"
                    name="phone">
                </div>
              </div>
              
              <div class="form-group">
                <label class="form-label">Site Web Actuel (si existant)</label>
                <input 
                  type="url" 
                  class="form-control" 
                  placeholder="https://www.votre-site.fr"
                  [(ngModel)]="formData.website"
                  name="website">
              </div>
            </div>
            
            <button type="button" class="suivant-button" (click)="nextStep()" 
              [disabled]="!formData.name || !formData.email || !formData.company || !isValidEmail(formData.email)">
              Suivant
            </button>
          </div>

          <!-- Step 2: Project Requirements -->
          <div *ngIf="currentStep === 2" class="form-step">
            <h3 class="step-title">Détails Du Projet</h3>
            
            <div class="form-group">
              <label class="form-label">Services Souhaités <span class="required">*</span> 
                <span class="service-count" *ngIf="getSelectedServicesCount() > 0">({{ getSelectedServicesCount() }} sélectionnés)</span>
              </label>
              <div class="services-grid">
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.webSite" name="webSite">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Création de site web</span>
                    <span class="service-desc">Site vitrine, corporate, institutionnel</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.ecommerce" name="ecommerce">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">E-commerce</span>
                    <span class="service-desc">Boutique en ligne, marketplace</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.development" name="development">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Développement d'application</span>
                    <span class="service-desc">Web app, mobile app, PWA</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.seo" name="seo">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Référencement SEO</span>
                    <span class="service-desc">Optimisation pour Google</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.advertising" name="advertising">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Publicité en ligne</span>
                    <span class="service-desc">Google Ads, Facebook Ads</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.socialMedia" name="socialMedia">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Gestion des réseaux sociaux</span>
                    <span class="service-desc">Community management, contenu</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.design" name="design">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Design graphique</span>
                    <span class="service-desc">Logo, identité visuelle, branding</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.photo" name="photo">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Photographie / Vidéographie</span>
                    <span class="service-desc">Photos produits, vidéos promo</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.copywriting" name="copywriting">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Copywriting</span>
                    <span class="service-desc">Rédaction de contenu</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.maintenance" name="maintenance">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Maintenance</span>
                    <span class="service-desc">Support technique, mises à jour</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.consulting" name="consulting">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Conseil stratégique</span>
                    <span class="service-desc">Audit, stratégie digitale</span>
                  </div>
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.global" name="global">
                  <span class="checkmark"></span>
                  <div class="service-info">
                    <span class="service-name">Accompagnement global</span>
                    <span class="service-desc">Solution complète, tout-en-un</span>
                  </div>
                </label>
              </div>
            </div>
            
            <div class="form-navigation">
              <button type="button" class="prev-button" (click)="previousStep()">
                Précédent
              </button>
              <button type="button" class="suivant-button" (click)="nextStep()" 
                [disabled]="!hasSelectedServices()">
                Suivant
              </button>
            </div>
          </div>

          <!-- Step 3: Additional Details -->
          <div *ngIf="currentStep === 3" class="form-step">
            <h3 class="step-title">Informations Complémentaires</h3>
            
            <div class="form-group">
              <label class="form-label">Sujet / Titre Du Projet <span class="required">*</span></label>
              <input 
                type="text" 
                class="form-control" 
                placeholder="Ex: Création d'un site e-commerce pour ma boutique de mode"
                [(ngModel)]="formData.subject"
                name="subject"
                required>
            </div>
            
            <div class="form-group">
              <label class="form-label">Description Détaillée Du Projet <span class="optional">(Facultatif)</span></label>
              <p class="field-hint">Plus vous donnez de détails, plus notre devis sera précis et adapté à vos besoins.</p>
              <textarea 
                class="form-control textarea" 
                placeholder="Décrivez votre projet en détail: fonctionnalités souhaitées, inspirations, contraintes techniques, exemples de sites que vous aimez, budget estimé, date de lancement souhaitée, etc."
                [(ngModel)]="formData.details"
                name="details"
                rows="8"></textarea>
            </div>
            
            <label class="terms-checkbox">
              <input 
                type="checkbox" 
                [(ngModel)]="formData.acceptTerms" 
                name="acceptTerms"
                required>
              <span class="checkmark"></span>
              <span class="terms-text">
                En cochant cette case, j'accepte que Digital Alchemy traite mes données personnelles pour l'établissement d'un devis. 
                Je reconnais avoir pris connaissance de la <span class="link-text">Politique de Confidentialité</span> et des 
                <span class="link-text">Conditions Générales d'Utilisation</span>.
              </span>
            </label>
            
            <div class="form-navigation">
              <button type="button" class="prev-button" (click)="previousStep()">
                Précédent
              </button>
              <button 
                type="submit" 
                class="suivant-button submit-button"
                [disabled]="!formData.acceptTerms || !formData.subject || isSubmitting"
                [class.button-loading]="isSubmitting">
                <span *ngIf="!isSubmitting">📩 Envoyer Ma Demande De Devis</span>
                <span *ngIf="isSubmitting" class="loading-spinner">Envoi en cours...</span>
              </button>
            </div>
          </div>
          
        </form>
        
        <!-- Success State -->
        <div *ngIf="submissionSuccess" class="success-state">
          <div class="success-content">
            <div class="success-icon-large">✓</div>
            <h3>Demande De Devis Reçue Avec Succès!</h3>
            <p>Merci pour votre confiance. Notre équipe d'experts analyse actuellement votre projet en détail.</p>
            <div class="success-details">
              <div class="detail-item">
                <span class="icon">📧</span>
                <span>Vous recevrez votre devis personnalisé par email sous <strong>24 heures</strong></span>
              </div>
              <div class="detail-item">
                <span class="icon">📞</span>
                <span>Un expert vous contactera pour une consultation gratuite de <strong>30 minutes</strong></span>
              </div>
              <div class="detail-item">
                <span class="icon">💼</span>
                <span>Votre projet est désormais référencé sous le nom: <strong>{{ formData.subject }}</strong></span>
              </div>
            </div>
            <button type="button" class="suivant-button" (click)="resetForm()">
              Faire Une Nouvelle Demande
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</section>

<!-- Why Request a Quote Section -->
<section class="why-devis-section">
  <div class="container">
    <h2 class="section-title">Pourquoi Demander Un Devis Chez Digital Alchemy ?</h2>
    
    <div class="benefits-grid">
      <div class="benefit-card">
        <div class="benefit-icon">🎯</div>
        <h3>Devis Personnalisé</h3>
        <p>Chaque projet est unique. Nous analysons vos besoins spécifiques pour vous proposer une solution sur-mesure adaptée à vos objectifs et votre budget.</p>
      </div>
      
      <div class="benefit-card">
        <div class="benefit-icon">💰</div>
        <h3>Prix Transparents</h3>
        <p>Aucun frais caché. Nous vous fournissons un devis détaillé avec une ventilation claire des coûts pour chaque service et fonctionnalité.</p>
      </div>
      
      <div class="benefit-card">
        <div class="benefit-icon">⚡</div>
        <h3>Réponse Rapide</h3>
        <p>Recevez votre devis détaillé sous 24 heures. Notre équipe d'experts analyse rapidement votre projet pour vous proposer la meilleure solution.</p>
      </div>
      
      <div class="benefit-card">
        <div class="benefit-icon">🤝</div>
        <h3>Accompagnement Gratuit</h3>
        <p>Bénéficiez d'une consultation gratuite de 30 minutes pour discuter de votre projet et recevoir des conseils d'experts avant même de commencer.</p>
      </div>
      
      <div class="benefit-card">
        <div class="benefit-icon">📊</div>
        <h3>Analyse Complète</h3>
        <p>Nous étudions votre marché, vos concurrents et vos opportunités pour vous proposer une stratégie digitale gagnante.</p>
      </div>
      
      <div class="benefit-card">
        <div class="benefit-icon">✨</div>
        <h3>Sans Engagement</h3>
        <p>Notre devis est totalement gratuit et sans engagement. Vous êtes libre de comparer et de choisir la meilleure offre pour votre entreprise.</p>
      </div>
    </div>
  </div>
</section>

<!-- Our Process Section -->
<section class="process-section">
  <div class="container">
    <h2 class="section-title">Notre Processus De Devis En 4 Étapes</h2>
    
    <div class="process-timeline">
      <div class="process-step">
        <div class="step-number">01</div>
        <div class="step-content">
          <h3>Remplissez Le Formulaire</h3>
          <p>Complétez notre formulaire détaillé en quelques minutes. Plus nous avons d'informations, plus votre devis sera précis et adapté.</p>
        </div>
      </div>
      
      <div class="process-step">
        <div class="step-number">02</div>
        <div class="step-content">
          <h3>Analyse Par Nos Experts</h3>
          <p>Notre équipe d'experts étudie votre projet, analyse vos besoins et prépare une proposition personnalisée avec des recommandations.</p>
        </div>
      </div>
      
      <div class="process-step">
        <div class="step-number">03</div>
        <div class="step-content">
          <h3>Réception Du Devis</h3>
          <p>Recevez votre devis détaillé par email sous 24 heures avec une ventilation complète des coûts et un planning prévisionnel.</p>
        </div>
      </div>
      
      <div class="process-step">
        <div class="step-number">04</div>
        <div class="step-content">
          <h3>Consultation Gratuite</h3>
          <p>Programmez un appel avec notre équipe pour discuter du devis, poser vos questions et affiner les détails de votre projet.</p>
        </div>
      </div>
    </div>
  </div>
</section>



<!-- What's Included Section -->
<section class="included-section">
  <div class="container">
    <h2 class="section-title">Ce Qui Est Inclus Dans Notre Devis</h2>
    
    <div class="included-grid">
      <div class="included-card">
        <div class="included-icon">📋</div>
        <h3>Analyse Détaillée</h3>
        <ul>
          <li>Étude de marché et concurrence</li>
          <li>Analyse de vos besoins</li>
          <li>Recommandations d'experts</li>
          <li>Stratégie digitale personnalisée</li>
        </ul>
      </div>
      
      <div class="included-card">
        <div class="included-icon">💎</div>
        <h3>Proposition Technique</h3>
        <ul>
          <li>Technologies recommandées</li>
          <li>Fonctionnalités détaillées</li>
          <li>Architecture du projet</li>
          <li>Spécifications techniques</li>
        </ul>
      </div>
      
      <div class="included-card">
        <div class="included-icon">📅</div>
        <h3>Planning Prévisionnel</h3>
        <ul>
          <li>Phases du projet</li>
          <li>Délais de réalisation</li>
          <li>Jalons importants</li>
          <li>Date de livraison estimée</li>
        </ul>
      </div>
      
      <div class="included-card">
        <div class="included-icon">💰</div>
        <h3>Tarification Transparente</h3>
        <ul>
          <li>Coût détaillé par service</li>
          <li>Options de paiement flexibles</li>
          <li>Aucun frais caché</li>
          <li>Garanties incluses</li>
        </ul>
      </div>
    </div>
  </div>
</section>



<!-- CTA Section -->
<section class="cta-section">
  <div class="container">
    <div class="cta-content">
      <h2>Besoin D'Aide Pour Remplir Le Formulaire ?</h2>
      <p>Notre équipe est disponible pour vous accompagner et répondre à vos questions</p>
      <div class="cta-buttons">
        <button class="btn-cta-primary" (click)="scrollToSection('devis-form-section')">
          <span>Remplir Le Formulaire</span>
          <i>→</i>
        </button>
        <div class="cta-phones">
          <a href="tel:+212690459525">+33 6 66 07 64 55</a>
          <span>|</span>
          <a href="mailto:Contact@digalchemy.com">Contact&#64;digalchemy.com</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FAQ Section -->
<section class="faq-section">
  <div class="container">
    <h2 class="section-title">Questions Fréquentes Sur Les Devis</h2>
    
    <div class="faq-grid">
      <div class="faq-item">
        <h3>Le devis est-il vraiment gratuit?</h3>
        <p>Oui, absolument! Notre devis est 100% gratuit et sans aucun engagement. Vous pouvez comparer avec d'autres agences en toute liberté.</p>
      </div>
      
      <div class="faq-item">
        <h3>Combien de temps pour recevoir le devis?</h3>
        <p>Vous recevrez votre devis détaillé par email dans un délai de 24 heures maximum après la soumission de votre demande.</p>
      </div>
      
      <div class="faq-item">
        <h3>Puis-je modifier ma demande après l'envoi?</h3>
        <p>Bien sûr! Contactez-nous simplement par email ou téléphone pour ajuster les détails de votre projet.</p>
      </div>
      
      <div class="faq-item">
        <h3>Le devis est-il négociable?</h3>
        <p>Nous sommes toujours ouverts à la discussion. Notre objectif est de trouver la meilleure solution adaptée à votre budget.</p>
      </div>
      
      <div class="faq-item">
        <h3>Que se passe-t-il après réception du devis?</h3>
        <p>Nous vous contactons pour une consultation gratuite de 30 minutes afin de discuter du devis et répondre à vos questions.</p>
      </div>
      
      <div class="faq-item">
        <h3>Mes informations sont-elles sécurisées?</h3>
        <p>Absolument. Toutes vos données sont cryptées et traitées en toute confidentialité conformément au RGPD.</p>
      </div>
    </div>
  </div>
</section>

<footer class="footer-section">
  <div class="footer-container">
    
    <!-- Main Footer Content -->
    <div class="footer-content">
      
      <!-- Section 1: Company Logo & Description -->
      <div class="footer-company">
        <div class="company-logo">
          <img src="assets/images/logo-white.png" alt="Rhillane Logo" />
        </div>
        
        <p class="company-description">
          Digital Alchemy, votre partenaire de confiance pour la création de sites web . 
          Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
        </p>
        
        <!-- Social Media -->
        <div class="social-media-section">
          <ul style="display: flex; gap: 16px; list-style: none; padding: 0; margin: 0;">
            
            <!-- Facebook -->
            <li style="margin: 0;">
              <a href="https://www.facebook.com/people/Digital-alchemy/61565618420833" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Facebook page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1877F2; fill: #1877F2;" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </li>
            
            <!-- Behance -->
            <li style="margin: 0;">
              <a href="https://www.behance.net/digitalalchemy2" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Behance page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1769FF; fill: #1769FF;" viewBox="0 0 24 24">
                  <path d="M0 4.4804V19.243h7.1554c.6613 0 1.3078-.0832 1.9297-.248.6288-.1654 1.1905-.4203 1.6792-.7661.485-.3431.8784-.7804 1.1677-1.3081.2862-.5258.4294-1.1471.4294-1.8641 0-.8784-.2067-1.6309-.6172-2.2506-.4073-.6172-.9897-1.0907-1.7494-1.4161.6388-.3431 1.1139-.8141 1.4285-1.4143.3146-.6002.4719-1.2755.4719-2.0274 0-.7193-.1327-1.3487-.4-1.8888-.2668-.5402-.6343-1.0033-1.0995-1.3914-.4652-.3881-.9712-.6884-1.5186-.8999C8.8135 4.5932 8.2071 4.4804 7.5446 4.4804H0zM15.3486 6.9795h4.7992v1.2755h-4.7992V6.9795zM3.2695 6.9795h3.8893c.9451 0 1.6612.2262 2.1463.6787.4851.4525.7277 1.0632.7277 1.8321 0 .8374-.2768 1.4676-.8323 1.8888-.5555.4212-1.2925.6323-2.2091.6323H3.2695V6.9795zM15.3486 13.2363h4.7992v1.2755h-4.7992v-1.2755zM3.2695 14.2834h4.3172c.6927 0 1.2944.1327 1.8051.3976.5107.2649.9378.6154 1.2755 1.0519.3377.4365.5849.9378.741 1.5044.1561.5666.2342 1.1543.2342 1.7632 0 .7193-.1014 1.3487-.3043 1.8888-.2029.5401-.5107.9949-.9237 1.3648-.4131.3699-.9378.6507-1.5743.8409-.6365.1902-1.3858.2853-2.2477.2853H3.2695v-7.0969z"/>
                </svg>
              </a>
            </li>
            
            <!-- LinkedIn -->
            <li style="margin: 0;">
              <a href="https://www.linkedin.com/company/digital-alchemy-ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our LinkedIn page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #0077B5; fill: #0077B5;" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </li>
            
            <!-- YouTube -->
            <li style="margin: 0;">
              <a href="https://www.youtube.com/@Digital_Alchemy_ma" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our YouTube page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #FF0000; fill: #FF0000;" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </li>
            
            <!-- Instagram -->
            <li style="margin: 0;">
              <a href="https://www.instagram.com/digital_alchemy_ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Instagram page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #E1306C; fill: #E1306C;" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </li>
            
          </ul>
        </div>
      </div>
      
      <!-- Section 2: Contact Information -->
      <div class="footer-contact">
        <h3 class="footer-title">CONTACT</h3>
        
        <div class="contact-info">
          <div class="contact-item">
            <span>+212 690 459 525</span>
          </div>
          <div class="contact-item">
            <span>+33 6 66 07 64 55</span>
          </div>
          <div class="contact-item">
            <span>Digitalalchemyma&#64;gmail.com</span>
          </div>
          <div class="contact-item">
            <span>Contact&#64;digalchemy.com</span>
          </div>
        </div>
        
        <div class="office-locations">
          <div class="office-item">
            <h4>NOTRE BUREAU AU MAROC</h4>
            <p>Bd Dammam, Technopark Casablanca , Maroc .</p>
          </div>
        </div>
      </div>
      
      <!-- Section 3: Services Column -->
      <div class="footer-links">
        <h3 class="footer-title">NOS SERVICES</h3>
        <ul class="footer-list">
          <li><a routerLink="/web">Sites Web</a></li>
<li><a routerLink="/appweb">Application Web</a></li>
          <li><a routerLink="/publicite">Publicité en ligne</a></li>
          <li><a routerLink="/gestion">Gestion des réseaux sociaux</a></li>
          <li><a routerLink="/design">Design Graphique</a></li>
          <li><a routerLink="/agence">Agence SEO</a></li>
        </ul>
      </div>
      
      <!-- Section 4: Quick Links Column -->
      <div class="footer-links">
        <h3 class="footer-title">LIENS RAPIDES</h3>
        <ul class="footer-list">
          <li><a routerLink="/">Accueil</a></li>
          <li><a routerLink="/apropos">À propos</a></li>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a routerLink="/cgu">Conditions Générales d'Utilisation</a></li>
          <li><a routerLink="/conf">Politique de Confidentialité</a></li>
        </ul>
      </div>
      
    </div>
    
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Digital Alchemy. Tous droits réservés. | 
          <a routerLink="/cgu">Mentions légales</a> | 
          <a routerLink="/conf">Politique des cookies</a>
        </p>
        <div class="footer-bottom-links">
          <a routerLink="/contact">Support</a>
        </div>
      </div>
    </div>
    
  </div>
</footer>

